var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"owal loading poster container"},[_c('owal-spinner-logo'),_c('span',{staticClass:"owal loading poster text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }